import { ReactNode, useEffect, useState } from "react";
import { subscribe } from "valtio";
import { useTreeViewContext } from "../../../controllers/TreeViewController/TreeViewController";
import { useTreeViewOpenedFolders } from "../../../controllers/TreeViewController/hooks/treeViewFolderHooks";
import {
	useIsSelecting,
	useToggleSelectItems,
	useToggleSelectionMode,
} from "../../../controllers/TreeViewController/hooks/treeViewItemsHooks";
import { selectedViewLayout } from "../../../controllers/TreeViewController/stores/selectedViewLayout";
import BetterCheckbox from "../../BetterCheckbox";
import { useModalNavigator } from "../../ModalNavigator/ModalNavigator";
import CertiblokIcon from "../../icons/CertiblokIcon";
import SwitchViewMenu from "../../tables/cells/SwitchViewMenu";

const TreeViewHeader = ({
	canCloseSelection,
	customHeader,
	onToggleAllSelection,
}: {
	canCloseSelection?: boolean;
	customHeader?: (props: { selectAllCheckbox: ReactNode; viewSwitchButton: ReactNode }) => ReactNode;
	onToggleAllSelection?: (areFavorite: boolean) => void;
}) => {
	const { pushModal } = useModalNavigator();

	const { canSwitchView, selectedItemIds } = useTreeViewContext();
	const openedItems = useTreeViewOpenedFolders();

	const [areAllItemsSelected, setAreAllItemsSelected] = useState(false);
	useEffect(() => {
		const toggleAllItemsSelection = () => {
			const loadedItems = openedItems.filter((item) => item.item.isLoading === false);
			const selectableItems = loadedItems.filter(({ item }) => item.item?.selectable ?? true);
			if (selectableItems.length > 0) setAreAllItemsSelected(selectedItemIds.values.length >= selectableItems.length);
		};
		toggleAllItemsSelection();
		return subscribe(selectedItemIds, () => {
			toggleAllItemsSelection();
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [openedItems]);
	const selectItems = useToggleSelectItems();
	const isSelecting = useIsSelecting();
	const toggleIsSelecting = useToggleSelectionMode();

	const checkbox = (
		<BetterCheckbox
			color="secondary"
			onClick={() => {
				if (areAllItemsSelected) {
					selectedItemIds.values.splice(0, selectedItemIds.values.length);
				} else {
					if (!isSelecting) {
						toggleIsSelecting();
					}
					const loadedItems = openedItems.filter((item) => item.item.isLoading === false);
					selectedItemIds.values.splice(0, selectedItemIds.values.length);
					selectedItemIds.values.push(
						...loadedItems
							.filter(({ item }) => {
								return item.item?.selectable ?? true;
							})
							.map((item) => item.item.item?.id ?? "")
					);
				}
				onToggleAllSelection?.(!areAllItemsSelected);
			}}
			checked={areAllItemsSelected}
		/>
	);

	const viewSwitchButton = (
		<div
			className="flex items-center gap-1 cursor-pointer"
			onClick={(ev) => {
				pushModal(SwitchViewMenu, {
					anchorEl: ev.currentTarget,
				}).then((view) => {
					selectedViewLayout.value = view;
					if (isSelecting) {
						toggleIsSelecting();
					}
					selectItems({
						itemIds: [],
						shouldReplace: true,
					});
					onToggleAllSelection?.(false);
				});
			}}
		>
			<CertiblokIcon size={24} color="black" name={"tree_view"} />
			<CertiblokIcon size={16} color="black" name={"arrow_mini_outline_down"} />
		</div>
	);

	return (
		<div className="h-10 pr-3 pl-[2px] bg-[#E6F4F7] rounded-b-2xl flex items-center justify-between">
			{customHeader ? (
				customHeader({ selectAllCheckbox: checkbox, viewSwitchButton: viewSwitchButton })
			) : (
				<>
					<div className="flex items-center gap-2">
						{checkbox}
						{/* {isSelecting && canCloseSelection && (
							<Button
								children="Chiudi selezione"
								size="small"
								color="secondary"
								onClick={() => {
									toggleIsSelecting();
									selectItems({
										itemIds: [],
										shouldReplace: true,
									});
									onToggleAllSelection?.(false);
								}}
							/>
						)} */}
					</div>
					{canSwitchView && viewSwitchButton}
				</>
			)}
		</div>
	);
};
export default TreeViewHeader;
